import React, { useMemo } from "react";
import { LayoutTemplate, MapPin } from "lucide-react";
import { resolveAssetDisplayUrl } from "../../lib/assetUrl";
import PreviewModalShell from "./_PreviewModalShell";

export default function WebsiteHeaderPreviewModal({ data, onClose }) {
  const siteName = (data.siteName || "").trim() || "— Chưa nhập tên site —";
  const logoDisplay = resolveAssetDisplayUrl(data.logo?.url, data.logo?.key);
  const faviconDisplay = resolveAssetDisplayUrl(data.favicon?.url, data.favicon?.key);

  const seoTitle = useMemo(() => {
    return (
      (data.homepageSeoTitle || "").trim() || `${siteName} – Khám phá địa điểm, ẩm thực & văn hoá`
    );
  }, [data.homepageSeoTitle, siteName]);

  return (
    <PreviewModalShell
      icon={<LayoutTemplate size={17} />}
      title="Xem trước website"
      subtitle="Header và favicon (tab trình duyệt)."
      onClose={onClose}
    >
      <div className="space-y-3">
        <p className="text-xs text-slate-500">Mô phỏng nhanh header và favicon theo dữ liệu đang nhập.</p>

        <div className="overflow-hidden rounded-xl border border-white/10 shadow-lg ring-1 ring-black/5">
          <header className="border-b border-white/10 bg-primary/95 px-3 py-2.5 backdrop-blur-md sm:px-4">
            <div className="flex items-center justify-between gap-3">
              <div className="flex min-w-0 items-center gap-2.5">
                {logoDisplay ? (
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-white/15 bg-white/10">
                    <img
                      src={logoDisplay}
                      alt=""
                      className="max-h-9 max-w-9 object-contain"
                      referrerPolicy="no-referrer"
                    />
                  </div>
                ) : (
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-white/15 bg-white/10">
                    <MapPin size={17} className="text-white" />
                  </div>
                )}
                <div className="min-w-0 leading-tight">
                  <p className="truncate text-base font-bold tracking-tight text-white sm:text-lg">
                    {siteName}
                  </p>
                  <p className="hidden text-[10px] uppercase tracking-[0.2em] text-white/55 sm:block">
                    Khám phá thành phố sương mù
                  </p>
                </div>
              </div>
              <div className="hidden shrink-0 gap-3 text-[11px] font-medium text-white/75 sm:flex">
                <span>Bản đồ</span>
                <span>Địa điểm</span>
                <span>Liên hệ</span>
              </div>
            </div>
          </header>
        </div>

        <div className="rounded-lg border border-slate-200 bg-white p-3 text-xs text-slate-600">
          <p className="font-semibold text-slate-700">Favicon (tab trình duyệt)</p>
          <div className="mt-2 flex items-center gap-2 rounded border border-slate-200 bg-slate-100 px-2 py-1.5">
            {faviconDisplay ? (
              <img
                src={faviconDisplay}
                alt=""
                className="h-4 w-4 object-contain"
                referrerPolicy="no-referrer"
              />
            ) : (
              <span className="flex h-4 w-4 items-center justify-center rounded bg-slate-300 text-[8px] text-white">
                ?
              </span>
            )}
            <span className="truncate text-[11px] text-slate-500">{seoTitle.slice(0, 42)}…</span>
          </div>
        </div>
      </div>
    </PreviewModalShell>
  );
}

